export default {
  notFound: "الصفحة غير موجودة",
  goHome: "العودة",
};
